import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdvertisingMarketing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#ff779a",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.30769 10.4232H3.69231C2.97826 10.4232 2.29346 10.1395 1.78856 9.63463C1.28365 9.12973 1 8.44493 1 7.73088C1 7.01684 1.28365 6.33204 1.78856 5.82713C2.29346 5.32223 2.97826 5.03857 3.69231 5.03857H5.30769V10.4232Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.30762 10.4231C8.46742 10.4234 11.5565 11.3587 14.1858 13.1111L14.9999 13.6539V1.80774L14.1858 2.35051C11.5565 4.10298 8.46742 5.03824 5.30762 5.03851V10.4231Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.30763 10.4231C5.30717 11.1281 5.45014 11.8258 5.72785 12.4738C6.00555 13.1218 6.41219 13.7065 6.92301 14.1924",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAdvertisingMarketing;
